import React from "react";
import { useNavigate } from "react-router-dom";
import { CardContent } from "../misc/Card";
import { Button } from "../misc/Button";

const NicheUpsell: React.FC = () => {
    const navigate = useNavigate();
    return (
        <CardContent className="space-y-4 pb-8">
            <p className="text-sm text-gray-600">
                Find the clients you're best at helping, then get ready-to-film video ideas and scripts written for
                them, including what's happening in your towns this week.
            </p>
            <p className="text-sm text-gray-600 font-medium">My Niche is part of AI Pro.</p>
            <Button onClick={() => navigate("/settings/subscription")}>Upgrade to AI Pro</Button>
        </CardContent>
    );
};

export default NicheUpsell;
